import { getApi } from '../../api';
import { orders } from '../../endpoints';
import requireSuccessfulResponse from '../../utilities/requireSuccessfulResponse';

export async function getOrderDisplayDecimals(): Promise<unknown> {
  const api = await getApi();
  const response = await api.get(`${orders['']}/parameters/qtd_casas_decimais`);
  requireSuccessfulResponse(response);
  return response.data.data?.valor;
}
